import { useEffect, useCallback } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Problem } from "@/components/site/Problem";
import { Solution } from "@/components/site/Solution";
import { Takeaways } from "@/components/site/Takeaways";
import { Formula } from "@/components/site/Formula";
import { Docente } from "@/components/site/Docente";
import { Credibility } from "@/components/site/Credibility";
import { Location } from "@/components/site/Location";
import { Footer } from "@/components/site/Footer";
import Iscrizione from "@/pages/Iscrizione";

function Landing() {
  const navigate = useNavigate();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      smoothWheel: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const handleAnchor = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id === "#" || id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", handleAnchor);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", handleAnchor);
      lenis.destroy();
    };
  }, []);

  const goToIscrizione = useCallback(() => {
    navigate("/iscrizione");
  }, [navigate]);

  return (
    <div className="App noise-overlay">
      <Nav onCta={goToIscrizione} />
      <main>
        <Hero onCta={goToIscrizione} />
        <Problem />
        <Solution />
        <Takeaways />
        <Formula />
        <Docente />
        <Location />
        <Credibility />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/iscrizione" element={<Iscrizione />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
